import { render, staticRenderFns } from "./Precautions.vue?vue&type=template&id=317666e1&scoped=true&lang=pug&"
import script from "./Precautions.vue?vue&type=script&lang=js&"
export * from "./Precautions.vue?vue&type=script&lang=js&"
import style0 from "./Precautions.vue?vue&type=style&index=0&id=317666e1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317666e1",
  null
  
)

export default component.exports